import { waLink } from "@/lib/brand";

export const FloatingWhatsApp = () => {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 right-6 z-50 inline-flex items-center justify-center h-14 w-14 sm:h-16 sm:w-16 bg-[#25D366] text-white shadow-2xl wa-pulse hover:bg-[#1ebe57] transition-colors"
      style={{ borderRadius: "9999px" }}
    >
      <svg
        viewBox="0 0 32 32"
        className="h-7 w-7 sm:h-8 sm:w-8"
        fill="currentColor"
        aria-hidden
      >
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.066 0-.115-.025-.165-.05-.347-.143-1.396-.39-2.794-1.838-1.099-1.155-1.86-2.557-2.066-2.918-.207-.36-.026-.564.155-.738.18-.18.36-.41.54-.616.18-.205.207-.36.36-.616.155-.257.077-.482-.026-.642-.077-.155-.696-1.747-.953-2.388-.257-.642-.514-.514-.696-.514-.18 0-.385-.052-.59-.052s-.54.077-.823.36c-.282.283-1.082 1.05-1.082 2.557 0 1.508 1.107 2.97 1.262 3.176.155.205 2.18 3.51 5.347 4.79 3.146 1.276 3.146.85 3.71.797.566-.052 1.83-.745 2.087-1.464.257-.72.257-1.33.18-1.464-.077-.13-.282-.205-.59-.36zM16 0C7.16 0 0 7.16 0 16c0 2.825.738 5.594 2.137 8.026L0 32l8.182-2.137A15.93 15.93 0 0016 32c8.84 0 16-7.16 16-16S24.84 0 16 0zm0 29.286a13.27 13.27 0 01-6.78-1.857l-.487-.287-5.054 1.32 1.346-4.918-.314-.503A13.32 13.32 0 012.714 16C2.714 8.66 8.66 2.714 16 2.714 23.34 2.714 29.286 8.66 29.286 16c0 7.34-5.946 13.286-13.286 13.286z" />
      </svg>
    </a>
  );
};
